module.exports = __webpack_public_path__ + "img/img37.2c3d9ee2.svg";